import aqilaApi from './aqila-api';
import { GrupoMaquina } from '../@types';

class GruposMaquina {
  private readonly endpoint = 'v1/grupos_maquina';

  async list() {
    const { data } = await aqilaApi.get<GrupoMaquina[]>(this.endpoint);
    return data;
  }
}

export default new GruposMaquina();
